import { createContext, useContext, useMemo } from 'react'
import { io } from 'socket.io-client'

const opts = { path: '/ws' }

const SocketContext = createContext(null)

export const useSocket = () => useContext(SocketContext)

export const SocketProvider = ({ children, options = opts }) => {
  const socket = useMemo(() => io(process.env.API_URL, options), [])

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  )
}
